/** @format */

import React, { useState } from "react";
import Select from "../../../components/Select";
import ContentTop from "../../../components/ContentTop";
import Tabs from "../../../components/Tabs";
import Table15 from "../../../components/Table15";
import Table16 from "../../../components/Table16";

const NovegetatsiyaSahifa = () => {
  const [toggle, setToggle] = useState(1);
  const tabs = [
    { title: "1-Jadval", id: 1, type: "text" },
    { title: "2-Jadval", id: 2, type: "text" },
  ];
  return (
    <div>
      <ContentTop>
        <ul className='content-top-left suv-omborlari'>
          <li>Novegetatsiya</li>
          <div>
            <Tabs toggle={toggle} setToggle={setToggle} tabs={tabs} />
          </div>
        </ul>
        <ul className='content-top-right'>
          <Select date='2022' />
        </ul>
      </ContentTop>
      <div className='tabs-content table-box'>
        <div
          className={
            toggle == 1 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table15 />
        </div>
        <div
          className={
            toggle == 2 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table16 />
        </div>
      </div>
    </div>
  );
};

export default NovegetatsiyaSahifa;
